/**
 * This file contains constants related to product options.
 * 
 * All constants should be UPPERCASE.
 * All constants should be defined as const rather than let
 * All constants should be in alphabetical order.
 * All constants should be exported so other files can easily use them.
 * 
 * In ES6 and onward, semicolons are optional. They have been omitted in this file.
 */

export const BLIND_SHIPPING = 'blind-shipping'
export const BORDER_TYPE = 'border-type'
export const CANVAS_DEPTH = 'canvas-depth'
export const DIGITAL_PROOF = 'digital-proof'
export const HANGING_KIT = 'hanging-kit'
export const FLOATER_FRAME = 'floater-frame'
export const IMAGE_BORDER_TYPE = 'image-border-type'
export const METAL_EASEL = 'metal-easel'
export const MOUNTING_STUDS = 'mounting-studs'
export const NEXT_DAY_SHIPPING = 'next-day-shipping'
export const NEXT_DAY_SHIPPING_PROMO = 'next-day-shipping-promo'
export const PAPER_TYPE = 'paper-type'
export const PRIORITY_HANDLING = 'priority-handling'
export const PRIORITY_SHIPPING = 'priority-shipping'
